import React, {useState} from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import useOutsideClickHandler from "hooks/useOutsideClickHandler";
import './index.css';

type IndexFilter = {
    'All questions': number;
    'Flagged': number;
    'Answered': number;
    'Unanswered': number;
};

type Dropdown2Props = {
    children?: React.ReactNode;
    className?: string;
    data: IndexFilter; 
    instruction?: boolean;
    dataKey?: string;
    onSelect: (value: any) => void;
    placeholder?: string;
    required?: boolean;
    value?: any;
    isOpen: boolean;
    setIsOpen?: (value: any) => void;
}

function Dropdown2 ({
    children,
    className,
    data,
    instruction,
    dataKey,
    onSelect,
    placeholder,
    value,
    isOpen,
    setIsOpen
}: Dropdown2Props) {
    const ref = useOutsideClickHandler(()=> setIsOpen && setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
    }

    return (
        <div
            className={isOpen
                ? `dropdown2--open ${className}`
                : `dropdown2 ${className}`
            }
            ref={ref}
        >
            <div 
                className={isOpen
                    ? "dropdown2__value--selected" 
                    : "dropdown2__value" 
                }
                onClick={() => setIsOpen(!isOpen)}
            >
                {value
                    ?   <p>{value.toUpperCase()}</p>
                    :   placeholder
                    ?   <p className="dropdown2__placeholder">
                          {placeholder}
                        </p>
                    :   ''
                }
                {isOpen &&
                    <div className="dropdown2__items">
                        {Object.entries(data).map(([key, count], i) => (
                            <div className="dropdown2__itemContainer" onClick={()=> selectItem(key)}>
                                <div className="dropdown2__checkIcon">
                                    {value === key && <FaCheck />}
                                </div>
                                <div className="dropdown2__itemContent">
                                    <p
                                        key={i}
                                        className={ value === key
                                            ? 'dropdown2__item dropdown2__itemSelected'
                                            : 'dropdown2__item'
                                        }
                                    >
                                        {dataKey ? key[dataKey] : key}

                                    </p>
                                    <div className="dropdown2__count">
                                        {/* ({instruction ? count+1 : count}) */}
                                        ({count})
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {isOpen
                    ? <MdArrowDropUp className={isOpen? 'dropdown2__icon--selected':'dropdown2__icon'} />
                    : <MdArrowDropDown className='dropdown2__icon' />
                }
            </div>
        </div>
    )
}

export default Dropdown2;